let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lbYf0")).then(() => parcelRequire('17Zy6'));